export class Util {

    readFromDataAttribute(element, dataName) {
        return element.dataset ? element.dataset[dataName] : element.getAttribute(`data-${dataName}`); /*                    */
    }
}